import { render, staticRenderFns } from "./DialogFormView.vue?vue&type=template&id=4de31efc&scoped=true"
import script from "./DialogFormView.vue?vue&type=script&lang=js"
export * from "./DialogFormView.vue?vue&type=script&lang=js"
import style0 from "./DialogFormView.vue?vue&type=style&index=0&id=4de31efc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de31efc",
  null
  
)

export default component.exports